<template>
  <div id="app" class="flex flex-col min-h-screen bg-gray-50">
    <nav class="bg-white shadow-md">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16">
          <div class="flex items-center">
            <router-link to="/" class="flex items-center text-gray-800 no-underline">
              <img alt="ARAPL Logo" src="https://mpl-regionsud.fr/wp-content/uploads/2025/03/MPLpng_Logo-Maison-des-professions-liberales-1024x1024.png" class="h-10 w-10 mr-3">
              <span class="text-xl font-bold">Adhésion</span>
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    
    <main class="flex-1 w-full max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
      <router-view/>
    </main>
    
    <footer class="bg-gray-800 text-white text-center p-5 mt-10">
      <p>&copy; {{ currentYear }} MPL Région Sud - Tous droits réservés</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style>
/* Les styles globaux de base sont maintenant gérés par Tailwind via la directive @tailwind base dans tailwind.css */
body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Vous pouvez garder une police personnalisée si nécessaire */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
